import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/alert";
import { hideAlertEd1 } from "../../redux/actions/ed1AndEd2";
import Spinner from "../../components/presentationals/Spinner";
import CustomTable from "./table";
import {
  entConPerfHeaders,
  newAcqHeaders,
  upgradeByProductHeaders,
} from "../../utils/constants";

const EnterpriseConnectivityViews = (props) => {
  const dispatch = useDispatch();
  const {
    getAllAPI,
    ed2Modules,
    ed2Tiles,
    fetchNewAcqCsvApi,
    fetchUpgradeCsvApi,
  } = props;
  const {
    showAlert,
    showDateAlert,
    showErrorAlert,
    wirelineEntPerf,
    newAcq,
    upgradeByProduct,
    timestamp,
    csvLoading,
  } = useSelector((state) => state.Ed1AndEd2Reducer);
  return (
    <div>
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        {ed2Modules?.modSecMasterTxDtos?.[0]?.sectionName}
      </h2>
      <Alert
        showAlert={showAlert}
        showDateAlert={showDateAlert}
        showError={showErrorAlert}
        hideAlert={() => dispatch(hideAlertEd1())}
      />
      {getAllAPI && getAllAPI.loading ? (
        <Spinner />
      ) : ed2Modules?.isModuleActive === "Y" ? (
        <>
          <>
            {ed2Tiles?.[0].isTileActive === "Y" ? (
              <CustomTable
                data={ed2Tiles?.[0]}
                headers={entConPerfHeaders}
                tableData={wirelineEntPerf}
              />
            ) : null}
            {ed2Tiles?.[1].isTileActive === "Y" ? (
              <CustomTable
                data={ed2Tiles?.[1]}
                headers={newAcqHeaders}
                tableData={newAcq}
                csvHandler={fetchNewAcqCsvApi}
                csvLoading={csvLoading.newAcq}
                timestamp={timestamp?.data?.content?.SAF}
              />
            ) : null}
            {ed2Tiles?.[2].isTileActive === "Y" ? (
              <CustomTable
                data={ed2Tiles?.[2]}
                headers={upgradeByProductHeaders}
                tableData={upgradeByProduct}
                csvHandler={fetchUpgradeCsvApi}
                csvLoading={csvLoading.upgrade}
                timestamp={timestamp?.data?.content?.MACD}
              />
            ) : null}
          </>
        </>
      ) : null}
    </div>
  );
};

export default EnterpriseConnectivityViews;
